import styled from 'styled-components'

type StyledProps = {
  isExpanded?: boolean
}

const StyledCreateBarHashtagsRecommended = styled.div<StyledProps>`
  user-select: none;
  position: relative;
  overflow: hidden;
  max-height: 75px;
  transition: 0.2s;
  border-bottom: 1px solid ${({ theme }) => theme.color.gray[300]};

  .recommended-sizer {
    .recommended-header {
      padding: 20px 20px 16px 20px;

      .title {
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.color.gray[800]};
        font-weight: 600;

        svg {
          height: 18px;
          margin-right: 4px;
        }
      }

      .sub-title {
        margin-top: 4px;
        display: block;
        color: ${({ theme }) => theme.color.gray[500]};
        font-size: 15px;
      }
    }

    .hashtag-list {
      padding: 0 20px 20px 20px;
      display: grid;
      gap: 10px;

      .hashtag-btn {
        height: 36px;
        border-radius: 50rem;
        transition: 0.2s;
        background-color: ${({ theme }) => theme.color.gray[100]};
        color: ${({ theme }) => theme.color.gray[600]};

        &:hover {
          background-color: ${({ theme }) => theme.color.gray[200]};
        }
      }
    }
  }

  .toggle-btn {
    position: absolute;
    top: 20px;
    right: 20px;
    border-radius: 50%;
  }

  ${({ isExpanded }) =>
    isExpanded &&
    `
      max-height: 238px;
  `}
`

export default StyledCreateBarHashtagsRecommended
